import React from 'react';
import {getComponentConfig} from '../../utils/components';
import ContentLoader from "../layout/ContentLoader";
import PropTypes from "prop-types";
import {store} from "src/store";
import {showModal} from "../../actions";
import {trace} from "../../utils/request";
import Icon from "./Icon";
import {set} from "../../utils/dotutils";
import PropsProxy from "../layout/PropsProxy";
import axios from "axios";
import debounce from "../../utils/debounce";

export default class ComponentConfig extends React.Component {

    static propTypes = {
        componentName: PropTypes.string,
        componentConfigAs: PropTypes.string,
        loader: PropTypes.any,
        onLoadCompleted: PropTypes.func,
        onBeforeLoad: PropTypes.func,
    }

    state = {
        isLoading: true,
        failed: false,
        config: null,
    }

    constructor(props) {
        super(props);
        this.loadConfigDebounce = debounce(() => {
            return new Promise(async (resolve, reject) => {
                if (this.props.onBeforeLoad) {
                    await this.props.onBeforeLoad();
                }
                this.loadConfigRequest && this.loadConfigRequest.abort();
                this.loadConfigRequest = getComponentConfig(this.props.componentName);
                this.loadConfigRequest.then(async (config) => {
                    if (!config) {
                        const e = {message: "Empty config!"};
                        reject(e);
                        if (this.mounted) {
                            this.setState({failed: e, isLoading: false, config: null});
                        }
                    } else {
                        if (this.props.onLoadCompleted) {
                            await this.props.onLoadCompleted(config);
                        }
                        resolve(config);
                        if (this.mounted) {
                            this.setState({isLoading: false, config, failed: false});
                        }
                    }
                });
                this.loadConfigRequest.catch((e) => {
                    if (!(e instanceof axios.Cancel)) {
                        reject(e);
                        console.error(e);
                        if (this.mounted) {
                            this.setState({failed: e, isLoading: false, config: null});
                            !this.props.onFailure && store.dispatch(showModal({
                                size: "large",
                                theme: "danger",
                                header: "Szerveroldali hiba",
                                body: trace(e)
                            }));
                        }
                    }
                });
            });
        }, 300);
    }

    loadConfig = () => {
        this.setState({isLoading: true, failed: false, config: null});
        return this.loadConfigDebounce();
    }

    componentDidMount() {
        this.mounted = true;
        this.currentLoadConfig = this.loadConfig();
    }

    componentWillUnmount() {
        this.mounted = false;
        this.currentLoadConfig && this.currentLoadConfig.cancel();
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if(prevProps.componentName !== this.props.componentName) {
            this.loadConfig();
        }
    }

    render () {
        let component = null;
        const props = {...this.props};
        Object.keys(ComponentConfig.propTypes).map((key) => {
            delete props[key];
        });
        if (!this.state.isLoading && !this.state.failed) {
            set(props, this.props.componentConfigAs || "componentConfig", this.state.config);
            component = <PropsProxy {...props} />;
        } else if(this.state.failed) {
            if (this.props.onFailure) {
                component = this.props.onFailure && this.props.onFailure(this.state.failed);
            }
        }
        let LoaderStyle;
        if (this.props.loader !== undefined) {
            LoaderStyle = this.props.loader;
        }
        if (this.state.isLoading) {
            if (LoaderStyle) {
                return <LoaderStyle {...props}>
                    {component}
                </LoaderStyle>;
            } else {
                if (LoaderStyle === false) {
                    return <PropsProxy {...props}>{this.props.children}</PropsProxy>;
                }
                return React.Children.map(this.props.children, (child) => {
                    if (child?.type?.placeHolder) {
                        return <child.type.placeHolder
                            {...child.props}
                        />;
                    } else {
                        return <ContentLoader {...props}>
                            {component}
                        </ContentLoader>;
                    }
                });
            }
        } else {
            return component || <span onClick={(e) => {
                e && e.preventDefault();
                console.error(this.state.failed);
                store.dispatch(showModal({
                    size: "large",
                    theme: "danger",
                    header: "Szerveroldali hiba",
                    body: trace(this.state.failed.response.data)
                }))
            }}>
                <Icon lib="fa" name="exclamation-triangle" />
            </span>;
        }
    }
}